import { atom } from 'jotai'

export type TOrderLineItem = {
    catalogSlide?: {
        content: {
            description?: string
        }
    }
    item?: {
        id: number | string
    }
    number?: number | string
    quantity?: number | string
    pv?: number | string
    product?: string
}

export type TOrderDetail = {
    FulfillmentStatus?: string
    status?: string
    ResultId?: number | string
    dateCreated?: string
    shipToName?: {
        fullName?: string
    }
    terms?: {
        period?: string
        pv?: number | string
        taxableTotal?: number | string
        total?: number | string
    }
    lines?: {
        items?: TOrderLineItem[]
    }
}

export type TOrderHistoryRow = {
    order_id: string
    order_detail: TOrderDetail
}

export const orderHistoryAtom = atom<TOrderHistoryRow[]>([])
export const orderHistoryIsLoadingAtom = atom(false)
export const orderHistoryErrorAtom = atom('')
export const orderHistoryLastBaidAtom = atom<string | null>(null)